module.exports = __webpack_public_path__ + "img/icon1.b3d440e8.png";